import React, { useState, useMemo } from "react";
import "../../filters.css";

export default function ProductFilters({ products, onChange }) {
  const [selected, setSelected] = useState([]);

  // Get all unique tags from products
  const allTags = useMemo(() => {
    return [...new Set(products.flatMap(product => product.tags || []))];
  }, [products]);

  const toggleTag = (tag) => {
    const updated = selected.includes(tag)
      ? selected.filter((t) => t !== tag)
      : [...selected, tag];

    setSelected(updated);
    onChange(updated);
  };

  const clearAll = () => {
    setSelected([]);
    onChange([]);
  };

  return (
    <div className="filter-wrapper">

      <h3 className="filter-title">Filter: </h3>

      <div className="filter-tags-container">
        {allTags.map((tag) => (
          <button
            key={tag}
            className={`filter-tag ${selected.includes(tag) ? "active" : ""}`}
            onClick={() => toggleTag(tag)}
          >
            {tag}
          </button>
        ))}
      </div>

      {selected.length > 0 && (
        <button className="clear-btn" onClick={clearAll}>
          Clear all
        </button>
      )}

    </div>
  );
}
